module.exports = __webpack_public_path__ + "static/media/roadmap.60be89f2.jpg";